import styles from 'assets/styles/default.scss';
import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const topBarHeight = 52;
export const topBarMenusHeight = 32;

export const topBarSubMenuItemStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      wrapper: {
      },
      label: {
        fontWeight: 700,
        color: styles.primarySicredi + ' !important',
      },
      icon: {
        color: styles.primarySicredi + ' !important',
        fontSize: '11px !important',
        minWidth: 'initial',
        paddingRight: theme.spacing(1)
      },
    }),
  {
    name: 'TopBarMenuItem',
  }
);

export const topBarMenuItemStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      labelButton: {
        fontWeight: 700
      },
      icon: {
        fontSize: '16px !important'
      },
    }),
  {
    name: 'TopBarMenuItem',
  }
);

export const topBarMenusStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      relativeWrapper: {
        display: 'block',
        width: '100%',
        height: '0',
        maxHeight: topBarMenusHeight + 'px',
        transition: 'height ease-out 0.3s',
      },
      shownRelativeWrapper: {
        height: topBarMenusHeight + 'px',
      },
      fixedWrapper: {
        backgroundColor: 'white',
        maxHeight: topBarMenusHeight + 'px',
        position: 'fixed',
        top: (topBarHeight - topBarMenusHeight) + 'px',
        left: 0,
        width: '100%',
        height: '100%',
        transition: 'top ease-out 0.3s',
        zIndex: 1000,
        lineHeight: topBarMenusHeight + 'px',
        padding: '0 15px',
      },
      shownFixedWrapper: {
        top: topBarHeight + 'px',
      }
    }),
  {
    name: 'TopBarMenus',
  }
);

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      wrapper: {
        background: '#FFF !important',
        color: styles.primarySicredi + ' !important',
        transition: 'box-shadow ease-out 0.3s',
      },
      lightShadowWrapper: {
        boxShadow: '0 -7px 15px rgba(0, 0, 0, 0.3) !important',
      },
      bar: {
        minHeight: topBarHeight + 'px !important',
        maxHeight: topBarHeight + 'px !important',
      },
      logoButton: {
        marginRight: '15px',
        height: '30px',
        cursor: 'pointer',
      },
      loginButton: {
        color: 'styles.primarySicrediDark !important',
      },
      saudacao: {
        alignSelf: 'flex-end',
        textTransform: 'capitalize',
        lineHeight: topBarHeight + 'px !important',
      },
      userMenuButton: {
        fontSize: '0.8rem !important',
      },
    }),
  {
    name: 'TopBarMenus',
  }
);